import { Services } from '@sigma-frontend-libs/commons'

import { labelModes } from '@/utils'

import buttonFilter from '@/components/button/filter'
import filterDate from '@/components/filter/date'
import selectorOwner from '@/components/selector/owner'

function renderDateFilter(h) {
  return h(
    filterDate,
    {
      props: {
        value: this.proxy.createdAt,
        preset: this.proxy.createdAtPreset,
        presets: true,
        clearable: true,
        backendGeneration: 'nest'
      },
      on: {
        input: event => {
          this.proxy.createdAt = event
        },
        preset: event => {
          this.proxy.createdAtPreset = event
        }
      }
    }
  )
}

function renderOwner(h) {
  return h(
    selectorOwner,
    {
      props: {
        value: this.proxy.ownerId,
        label: this.getTranslate(`${Services['url-shortener']}.labels.owner`),
        labelMode: labelModes.hidden,
        dense: true
      },
      on: {
        input: event => {
          this.proxy.ownerId = event
        }
      }
    }
  )
}
function renderFields(h) {
  return [ renderOwner.call(this, h) ]
}

function renderButtonFilter(h) {
  if (this.canGetUsers) {
    return h(
      buttonFilter,
      {
        props: {
          value: this.proxy,
          defaultValue: this.defaultFilter
        },
        on: {
          input: event => {
            this.proxy = event
          }
        }
      },
      renderFields.call(this, h)
    )
  }
}

function renderContentByViewport(h) {
  if (this.viewport.breakpoint.lgUp) {
    return renderButtonFilter.call(this, h)
  } else {
    return h(
      'div',
      {
        class: 'grid grid-gap--8'
      },
      renderFields.call(this, h)
    )
  }
}

export default function(h) {
  return h(
    'div',
    {
      class: {
        [`${Services['url-shortener']}-filter`]: true,
        [`${Services['url-shortener']}-filter--admin`]: this.canGetUsers
      }
    },
    [
      renderDateFilter.call(this, h),
      renderContentByViewport.call(this, h)
    ]
  )
}
